module.exports = __webpack_public_path__ + "static/media/bg.3ffb12b2.jpg";